<template>
	<Layouts>
		<!-- ここに画面のタイトルを入力する -->
		<template v-slot:title>
			<div class="contents_header">
				<Title
					:title="'KIZUNA 顧客'"
					:subTitle="'新規作成'"
					:text="''"
					:icon="'fa-address-book'"
				/>
			</div>
		</template>
		<!-- ここにコンテンツを入力する -->
		<template v-slot:contents>
			<div class="mx-auto mb-[70px] mt-12 w-[1024px]">
				<div class="contentBox w-full">
					<div class="text-[18px]">基本情報</div>
					<!-- /* ---------------------------------------------------------------------------
						タイプ
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6">
						<CheckboxArray
							v-model="formData.type"
							:checkbox-item="salesEnums.typeEnum"
							:name="'type'"
							:title="'タイプ'"
							:required="true"
							:disabled="false"
							:error-text="errors.type"
						/>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						監理種別,区分
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 監理種別 -->
						<div>
							<RadioForm
								v-model="formData.management_type"
								:title="'監理種別'"
								:name="'management_type'"
								:required="false"
								:radio-item="salesEnums.mgmt_type"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>

						<!-- 区分 -->
						<div class="ml-4">
							<RadioForm
								v-model="formData.category"
								:title="'区分'"
								:name="'category'"
								:required="false"
								:radio-item="salesEnums.category"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						企業名,法人番号
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 企業名 -->
						<div class="w-[70%]">
							<InputForm
								v-model="formData.company_name"
								:type="'text'"
								:title="'企業名'"
								:text="''"
								:required="true"
								:disabled="false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="errors.company_name"
								:kizuna-type="3"
							/>
						</div>

						<!-- 法人番号 -->
						<div class="ml-4 w-[30%]">
							<InputForm
								v-model="formData.corporate_number"
								:type="'text'"
								:title="'法人番号'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="13"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						郵便番号,住所
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6">
						<AddressForm
							v-model:zip1="formData.zip1"
							v-model:zip2="formData.zip2"
							v-model:address="formData.address"
							:kizuna-type="3"
							:title="{ zip: '郵便番号', address: '住所' }"
							:form-class="'w-full'"
							:required="{
								zip: false,
								address: false
							}"
							:disabled="false"
							:error-text="{
								zip1: errors.zip1,
								zip2: errors.zip2,
								address: errors.address
							}"
						/>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						電話番号,FAX,代表者名
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 電話番号 -->
						<div class="w-full">
							<InputForm
								v-model="formData.tel"
								:type="'text'"
								:title="'電話番号'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="13"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
						<!-- FAX -->
						<div class="ml-4 w-full">
							<InputForm
								v-model="formData.fax"
								:type="'text'"
								:title="'FAX'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="13"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
						<!-- 代表者名 -->
						<div class="ml-4 w-full">
							<InputForm
								v-model="formData.name"
								:type="'text'"
								:title="'代表者名'"
								:text="''"
								:required="false"
								:disabled="false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="3"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						担当者名（技能）,担当者名（特定）
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 担当者名（技能） -->
						<div class="w-full">
							<InputForm
								v-model="formData.skill_staff_name"
								:type="'text'"
								:title="'担当者名（技能）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 担当者名（特定） -->
						<div class="ml-4 w-full">
							<InputForm
								v-model="formData.spec_skill_staff_name"
								:type="'text'"
								:title="'担当者名（特定）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<div class="ml-4 w-full"></div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						企業URL
					---------------------------------------------------------------------------- */ -->
					<!-- 企業URL -->
					<div class="mt-6">
						<InputForm
							v-model="formData.company_url"
							:type="'text'"
							:title="'企業URL'"
							:text="''"
							:required="false"
							:disabled="false"
							:maxlength="255"
							:form-class="'w-full'"
							:error-text="''"
							:placeholder="'https://'"
							:kizuna-type="3"
						/>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						メールアドレス（一般監理）,メールアドレス（特定監理）
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- メールアドレス（一般監理） -->
						<div class="w-full">
							<InputTagForm
								v-model="formData.skill_staff_email"
								:type="'text'"
								:title="'メールアドレス（技能）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- メールアドレス（特定監理） -->
						<div class="ml-4 w-full">
							<InputTagForm
								v-model="formData.spec_skill_staff_email"
								:type="'text'"
								:title="'メールアドレス（特定監理）'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						許可日,許可期限,受入れ国
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 許可日 -->
						<div class="w-full">
							<DatePicker
								v-model="formData.approval_date"
								:title="'許可日'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 許可期限 -->
						<div class="ml-4 w-full">
							<DatePicker
								v-model="formData.approval_deadline"
								:title="'許可期限'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 受入れ国 -->
						<div class="ml-4 w-full">
							<MultiselectForm
								v-model="formData.receiving_country"
								:select-type="''"
								:enum="salesEnums.country"
								:title="'受入れ国'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						許可日,許可期限,受入れ国
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 介護職の有無 -->
						<div class="w-full">
							<InputForm
								v-model="formData.caregiver_job_availability"
								:type="'text'"
								:title="'介護職の有無'"
								:text="''"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 事業の有無 -->
						<div class="ml-4 w-full">
							<RadioForm
								v-model="formData.business_availability"
								:title="'事業の有無'"
								:name="'business_availability'"
								:required="false"
								:radio-item="salesEnums.isOrIsnt"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 状態 -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.status"
								:select-type="''"
								:enum="salesEnums.status"
								:title="'状態'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						架電結果,見込み,見込みなし
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 架電結果 -->
						<div class="w-full">
							<SelectForm
								v-model="formData.call_result"
								:select-type="''"
								:enum="salesEnums.call_result"
								:title="'架電結果'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 見込み -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.estimate"
								:select-type="''"
								:enum="salesEnums.estimate"
								:title="'見込み'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 見込みなし -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.no_estimate"
								:select-type="''"
								:enum="salesEnums.no_estimate"
								:title="'見込みなし'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						商談後状況,管理方法,管理方法（その他）
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 商談後状況 -->
						<div class="w-full">
							<SelectForm
								v-model="formData.post_meeting_status"
								:select-type="''"
								:enum="salesEnums.post_meeting_status"
								:title="'商談後状況'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 管理方法 -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.management_method"
								:select-type="''"
								:enum="salesEnums.management_method"
								:title="'管理方法'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 管理方法（その他） -->
						<div class="ml-4 w-full">
							<InputForm
								v-if="typeFlag != 2"
								v-model="formData.other_management_method"
								:type="'text'"
								:title="'管理方法（その他）'"
								:text="''"
								:required="false"
								:disabled="formData.management_method != 5 ? true : false"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:placeholder="''"
								:kizuna-type="1"
							/>
							<InputForm
								v-else
								v-model="formData.other_management_method"
								:type="'text'"
								:title="'管理方法（その他）'"
								:text="''"
								:required="false"
								:disabled="true"
								:maxlength="255"
								:form-class="'w-full'"
								:error-text="''"
								:placeholder="''"
								:kizuna-type="1"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						特定監理有無,商談月,申込月
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 特定監理有無 -->
						<div class="w-full">
							<RadioForm
								v-model="formData.has_specific_skill"
								:title="'特定監理有無'"
								:name="'has_specific_skill'"
								:required="false"
								:radio-item="salesEnums.isOrIsnt"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 商談月 -->
						<div class="ml-4 w-full">
							<MonthPicker
								v-model="formData.meeting_month"
								:title="'商談月'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 2 ? true : false"
								:error-text="''"
								:kizuna-type="1"
							/>
						</div>
						<!-- 申込月 -->
						<div class="ml-4 w-full">
							<MonthPicker
								v-model="formData.application_month"
								:title="'申込月'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						利用状況,解約理由,資料ダウンロードの有無
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6 flex">
						<!-- 利用状況 -->
						<div class="w-full">
							<SelectForm
								v-model="formData.usage_status"
								:select-type="''"
								:enum="salesEnums.usage_status"
								:title="'利用状況'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<!-- 解約理由 -->
						<div class="ml-4 w-full">
							<SelectForm
								v-model="formData.cancellation_reason"
								:select-type="''"
								:enum="salesEnums.cancellation_reason"
								:title="'解約理由'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:form-class="'w-full'"
								:placeholder="'未設定'"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<!-- 資料ダウンロードの有無 -->
						<div class="ml-4 w-full">
							<RadioForm
								v-model="formData.download_document"
								:title="'資料ダウンロードの有無'"
								:name="'download_document'"
								:required="false"
								:radio-item="salesEnums.isOrIsnt"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
					</div>
					<div class="mt-6 flex">
						<!-- 資料ダウンロードの月 -->
						<div class="w-full">
							<MonthPicker
								v-model="formData.download_month"
								:title="'資料ダウンロード月'"
								:form-class="'w-rem-20'"
								:required="false"
								:disabled="typeFlag == 1 ? true : false"
								:error-text="''"
								:kizuna-type="2"
							/>
						</div>
						<div class="ml-4 w-full"></div>
						<div class="ml-4 w-full"></div>
					</div>
					<!-- /* ---------------------------------------------------------------------------
						備考
					---------------------------------------------------------------------------- */ -->
					<div class="mt-6">
						<TextareaForm
							v-model="formData.remarks"
							:title="'備考'"
							:required="false"
							:disabled="false"
							:form-class="'w-full'"
							:maxlength="1000"
							:error-text="''"
							:placeholder="''"
							:kizuna-type="3"
						/>
					</div>
				</div>
			</div>
			<div class="buttonField flex justify-center">
				<Button
					:button-type="'button'"
					:button-class="'button-gray'"
					:button-icon="'fa-arrow-left'"
					:button-text="'戻る'"
					@click="back"
				/>

				<Button
					:button-type="'button'"
					:button-class="'button-red ml-12'"
					:button-icon="'fa-pen'"
					:button-text="'新規作成'"
					@click="store"
				/>
			</div>
		</template>
	</Layouts>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import Title from "@/components/atoms/Title.vue";
import Layouts from "@/components/layouts/Layouts.vue";
import AddressForm from "@/components/molecules/form/AddressForm.vue";
import CheckboxArray from "@/components/molecules/form/CheckboxArray.vue";
import DatePicker from "@/components/molecules/form/DatePicker.vue";
import InputForm from "@/components/molecules/form/InputForm.vue";
import InputTagForm from "@/components/molecules/form/InputTagForm.vue";
import MonthPicker from "@/components/molecules/form/MonthPicker.vue";
import MultiselectForm from "@/components/molecules/form/MultiselectForm.vue";
import RadioForm from "@/components/molecules/form/RadioForm.vue";
import SelectForm from "@/components/molecules/form/SelectForm.vue";
import TextareaForm from "@/components/molecules/form/TextareaForm.vue";
import { format } from "date-fns";
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
//store
import { useAuthStore } from "@/stores/AuthStore";
import { usePartsStore } from "@/stores/PartsStore";
// utils
import * as salesEnums from "@/enums/SalesEnums.js";
import toaster from "@/utils/Toaster.js";
// stubs
import * as salesStubs from "@/stubs/Sales.js";

// api
import FunctionApi from "@/api/FunctionApi.js";

const authStore = useAuthStore();
const partsStore = usePartsStore();
const functionApi = new FunctionApi();
/* ---------------------------------------------------------------------------
	router
---------------------------------------------------------------------------- */
const router = useRouter();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { alert } = toaster();
/* ---------------------------------------------------------------------------
	data
---------------------------------------------------------------------------- */
const filteredEnum1 = Object.fromEntries(
	Object.entries(salesEnums.mgmt_type).filter(([key, value]) => key !== "3")
);

const formData = ref({ ...salesStubs.form });
const typeFlag = ref(null);
const errors = ref([]);

watch(
	() => formData.value.type,
	val => {
		console.log(val);
		if (val === null) {
			typeFlag.value = null;
		} else if (Array.isArray(val)) {
			const has1 = val.includes("1");
			const has2 = val.includes("2");

			if (has1 && has2) {
				typeFlag.value = 3;
			} else if (has1) {
				typeFlag.value = 1;
				formatClear(2);
			} else if (has2) {
				typeFlag.value = 2;
				formatClear(1);
			} else {
				typeFlag.value = null;
			}
		} else {
			// 必要に応じてエラーハンドリング
			typeFlag.value = null;
		}
	}
);

function formatClear(value) {
	const format = value == 1 ? salesStubs.formatClear2 : salesStubs.formatClear1;

	for (let key in format) {
		if (formData.value.hasOwnProperty(key)) {
			formData.value[key] = format[key];
		}
	}
}

function store() {
	if (formData.value.approval_date != "") {
		formData.value.approval_date = format(
			formData.value.approval_date,
			"yyyy/MM/dd"
		);
	}
	if (formData.value.approval_deadline != "") {
		formData.value.approval_deadline = format(
			formData.value.approval_deadline,
			"yyyy/MM/dd"
		);
	}

	partsStore.detailLoader = true;
	functionApi.company.store(formData.value).then(res => {
		partsStore.detailLoader = false;
		if (res.result) {
			errors.value = [];
			alert("store");

			router.push("/sales/companies");
		} else {
			errors.value = res.errors;
			alert("error_store");
		}
	});
}

function back() {
	router.push("/sales/companies");
}
onMounted(() => {});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
</style>
